import axios from "axios";
import configurations from "commons/configurations";
import { AUTH_NAMESPACE, TOKEN } from "~/store/modules/auth";

const AxiosInstance = axios.create({
  baseURL: configurations.api.baseUri,
});

let quantidadeRequisicoes = 0;

const createInterceptorLoading = (VueInstance) => {
  AxiosInstance.interceptors.request.use((config) => {
    quantidadeRequisicoes++;
    VueInstance.showPageLoading();
    return config;
  });
  AxiosInstance.interceptors.response.use(
    (config) => {
      quantidadeRequisicoes--;
      if (quantidadeRequisicoes == 0) {
        VueInstance.hidePageLoading();
      }
      return config;
    },
    (error) => {
      quantidadeRequisicoes = 0;
      VueInstance.hidePageLoading();
      return Promise.reject(error);
    }
  );
};

const createInterceptorError = (VueInstance) => {
  const message = (error) => {
    VueInstance.$notifyError(error);
  };
  AxiosInstance.interceptors.response.use(
    (config) => {
      if(config?.data && config.headers['content-type'] !== 'application/pdf' && !config.data.sucesso) {
        message(config.data.mensagem);
      }
      return config;
    },
    (error) => {
      if (error?.response?.data?.mensagem) {
        message(error.response.data.mensagem);
      } else {
        message("Um erro inesperado aconteceu! Tente novamente mais tarde.");
      }
      return Promise.reject(error);
    }
  );
};

const createInterceptorToken = (VueInstance) => {
  AxiosInstance.interceptors.request.use((config) => {
    const token = VueInstance.$store.getters[`${AUTH_NAMESPACE}/${TOKEN}`];
    config.headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    return config;
  });
};

const AxiosPlugin = {
  install(Vue) {
    Vue.mixin({
      methods: {
        $api() {
          return AxiosInstance;
        },
      },
    });
  },
};

export {
  AxiosPlugin,
  AxiosInstance,
  createInterceptorError,
  createInterceptorLoading,
  createInterceptorToken,
};
